<template>
  <div class="app-container">
    <el-card class="filter-container" shadow="never">
      <el-row v-if="!bankNoOperatorMode">
        <el-form :inline="true">
          <el-form-item style="margin-bottom: 0">
            <el-input
              style="width: 100px"
              placeholder="ID"
              size="small"
              clearable
              v-model="pageQuery.id"
              @keyup.enter.native="HandleSearch()"
            />
            <el-input
              style="width: 130px"
              placeholder="帐户名"
              size="small"
              clearable
              v-model.trim="pageQuery.name"
              @keyup.enter.native="HandleSearch()"
            />
            <el-input
              v-if="['admin'].indexOf(userInfo.userType) !== -1"
              style="width: 160px"
              placeholder="指定代理"
              size="small"
              clearable
              v-model="pageQuery.specifyAgent"
              @keyup.enter.native="HandleSearch()"
            />
            <el-input
              style="width: 130px"
              placeholder="卡主用户名"
              size="small"
              clearable
              v-model="pageQuery.username"
              @keyup.enter.native="HandleSearch()"
            />
            <el-select
              style="width: 140px"
              placeholder="卡主类型"
              size="small"
              clearable
              v-model="pageQuery.customerType"
            >
              <el-option label="纯手动卡主" value="0"></el-option>
              <el-option label="卡主" value="1"></el-option>
            </el-select>
            <el-autocomplete
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
              class="inline-input"
              size="small"
              style="width: 150px"
              v-model="pageQuery.operatorUsername"
              :fetch-suggestions="querySuggestOperator"
              :trigger-on-focus="false"
              placeholder="操作员"
              @keyup.enter.native="HandleSearch()"
            ></el-autocomplete>
            <el-input
              style="width: 200px"
              placeholder="银行卡号码(支持模糊搜索)"
              size="small"
              clearable
              v-model.trim="pageQuery.bankNo"
              @keyup.enter.native="HandleSearch()"
            />
            <el-select
              v-model="pageQuery.checkOrderStatus"
              style="width: 120px"
              placeholder="查单"
              size="small"
              clearable
            >
              <el-option label="全部查单" value="2"></el-option>
              <el-option label="支付查单" value="0"></el-option>
              <el-option label="提现查单" value="1"></el-option>
            </el-select>
            <el-input
              style="width: 120px"
              placeholder="手机号"
              size="small"
              v-model="pageQuery.phone"
              clearable
              @keyup.enter.native="HandleSearch()"
            />
            <el-input
              v-if="['admin'].indexOf(userInfo.userType) !== -1"
              style="width: 150px"
              placeholder="协议代理地址"
              size="small"
              v-model="pageQuery.proxyHost"
              clearable
              @keyup.enter.native="HandleSearch()"
            />
            <el-input
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
              style="width: 150px"
              placeholder="设备号"
              size="small"
              clearable
              v-model="pageQuery.cloudPhoneDeviceNo"
              @keyup.enter.native="HandleSearch()"
            />
            <el-select
              v-model="pageQuery.dispatchMode"
              style="width: 120px"
              placeholder="派单模式"
              size="small"
              clearable
            >
              <el-option label="自动" value="0"></el-option>
              <el-option label="手动" value="1"></el-option>
              <el-option label="转换中" value="2"></el-option>
            </el-select>
            <el-select
              style="width: 140px"
              placeholder="检测状态"
              size="small"
              clearable
              v-model="pageQuery.statusCheck"
            >
              <el-option
                v-for="item in searchOption.statusCheck"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              style="width: 130px"
              placeholder="上线状态"
              size="small"
              clearable
              v-model="pageQuery.statusLogin"
            >
              <el-option
                v-for="item in searchOption.statusLogin"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              style="width: 130px"
              placeholder="用户启停状态"
              size="small"
              clearable
              v-model="pageQuery.userEnable"
            >
              <el-option
                v-for="item in searchOption.userEnable"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              placeholder="卡主短信心跳状态"
              size="small"
              clearable
              v-model="pageQuery.onlineStatus"
            >
              <el-option
                v-for="item in searchOption.customerStatusLogin"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              filterable
              clearable
              placeholder="全部银行"
              size="small"
              v-model="pageQuery.bankCode"
            >
              <el-option
                v-for="item in bankOptions"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              style="width: 150px"
              placeholder="集团代码"
              size="small"
              v-model="pageQuery.bankGroupCode"
              clearable
              @keyup.enter.native="HandleSearch()"
            />
            <el-select
              v-if="!isFinance"
              style="width: 100px"
              clearable
              placeholder="视频状态"
              size="small"
              v-model="pageQuery.faceVideoStatus"
            >
              <el-option
                v-for="item in faceVideoStatusOptions"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              filterable
              clearable
              v-if="['admin'].indexOf(userInfo.userType) !== -1"
              v-model="pageQuery.groupCode"
              placeholder="级距分组"
              size="small"
            >
              <el-option
                v-for="option in amsBankCardPriorityGroupBySelectOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 130px"
              placeholder="扫脸状态"
              size="small"
              clearable
              v-model="pageQuery.statusRom"
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
            >
              <el-option label="无标记需扫脸" value="0"></el-option>
              <el-option label="已标记需扫脸" value="1"></el-option>
            </el-select>
            <el-select
              v-if="
                ['admin'].indexOf(userInfo.userType) !== -1 &&
                !bankNoOperatorMode
              "
              style="width: 130px"
              placeholder="控管状态"
              size="small"
              clearable
              v-model="pageQuery.accountRatingStatus"
            >
              <el-option label="一般卡" value="0"></el-option>
              <el-option label="观察卡" value="1"></el-option>
              <el-option label="新卡" value="2"></el-option>
            </el-select>
            <el-checkbox
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
              style="margin-left: 10px"
              v-model="pageQuery.isOperatorUser"
            >
              仅查询已指派操作员
            </el-checkbox>
            <el-checkbox
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
              style="margin-left: -20px"
              v-model="pageQuery.hasCloudPhone"
            >
              仅查询已分配设备
            </el-checkbox>
            <el-checkbox
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
              style="margin-left: -20px"
              v-model="pageQuery.hasFaceVideo"
            >
              仅查询已上传扫脸视频
            </el-checkbox>
            <el-checkbox
              v-if="['admin', 'super_admin'].indexOf(userInfo.userType) !== -1"
              style="margin-left: -20px"
              v-model="pageQuery.includeDeleted"
            >
              包含已删除银行卡
            </el-checkbox>
          </el-form-item>
          <el-form-item v-if="!isFinance" label="积分">
            <el-input
              style="width: 100px"
              placeholder="大于等于"
              size="small"
              clearable
              v-model.trim="pageQuery.minJifenBalance"
              @keyup.enter.native="HandleSearch()"
            />
            -
            <el-input
              style="width: 100px"
              placeholder="小于等于"
              size="small"
              clearable
              v-model.trim="pageQuery.maxJifenBalance"
              @keyup.enter.native="HandleSearch()"
            />
          </el-form-item>
          <el-form-item label="余额">
            <el-input
              style="width: 100px"
              placeholder="大于等于"
              size="small"
              clearable
              v-model.trim="pageQuery.minBalance"
              @keyup.enter.native="HandleSearch()"
            />
            -
            <el-input
              style="width: 100px"
              placeholder="小于等于"
              size="small"
              clearable
              v-model.trim="pageQuery.maxBalance"
              @keyup.enter.native="HandleSearch()"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              size="small"
              :loading="tableLoading"
              @click="HandleSearch()"
            ></el-button>
          </el-form-item>
        </el-form>
        <div style="float: right">
          <el-button
            plain
            round
            icon="el-icon-refresh-left"
            type="success"
            size="mini"
            @click="HandleReload()"
            >刷新列表</el-button
          >
          <el-tooltip
            class="item"
            effect="dark"
            content="检测、上线、用户启停、卡主短信心跳 状态重置"
            placement="bottom"
          >
            <el-button
              plain
              round
              icon="el-icon-refresh"
              type="warning"
              size="mini"
              @click="HandleStatusReset()"
              >状态重置</el-button
            >
          </el-tooltip>
          <el-button
            plain
            round
            icon="el-icon-refresh"
            type="warning"
            size="mini"
            @click="HandleReset()"
            >重置</el-button
          >
          <el-button
            v-if="
              ['agent', 'operator_admin', 'finance', 'agent_assistant'].indexOf(
                userInfo.userType
              ) === -1
            "
            plain
            round
            icon="el-icon-plus"
            @click="HandleAdd()"
            type="primary"
            size="mini"
            >创建</el-button
          >
          <el-button
            v-if="['admin'].indexOf(userInfo.userType) !== -1"
            plain
            round
            icon="el-icon-document-checked"
            @click="HandleBankMultipleSelectionDialog()"
            size="mini"
          >
            <span>
              批量级距操作
              {{
                multipleSelection.length > 0
                  ? "(" + multipleSelection.length + ")"
                  : ""
              }}</span
            >
          </el-button>
          <el-button
            v-if="['admin'].indexOf(userInfo.userType) !== -1"
            plain
            round
            icon="el-icon-apple"
            @click="HandleProxyMultipleSelectionDialog()"
            size="mini"
          >
            <span
              >批量协议地址操作
              {{
                multipleSelection.length > 0
                  ? "(" + multipleSelection.length + ")"
                  : ""
              }}</span
            >
          </el-button>
          <el-button
            v-if="['admin'].indexOf(userInfo.userType) !== -1"
            plain
            round
            icon="el-icon-video-camera-solid"
            @click="HandleBankMultipleDeleteAccVideo()"
            size="mini"
          >
            <span>
              <span v-if="multipleSelection.length > 1">批量移除视频</span>
              <span v-else>移除视频</span>
              {{
                multipleSelection.length > 0
                  ? "(" + multipleSelection.length + ")"
                  : ""
              }}</span
            >
          </el-button>
        </div>
      </el-row>

      <el-row v-else-if="!tableLoading">
        <span class="pass-text" v-if="total === 0">
          恭喜你，没有更多需要分配的银行卡了。感谢您让平台运转更加流畅～
        </span>
        <span class="warning-text" v-else>
          本页是经系统检测准备就绪的银行卡。请操作员管理员随时留意是否有卡未分配。<br /><br />终极目标是：随时保持此列表没有任何数据。所以有问题的卡，也需要将其标记下线。以保持待分配数量为
          0。
        </span>
      </el-row>
    </el-card>
    <CusScroll v-if="!tableLoading" ref-target="table" />
    <div class="table-container">
      <el-table
        border
        stripe
        ref="table"
        v-loading="tableLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
        :data="dataList"
        @selection-change="handleSelectionChange"
        :class="!expandOperation ? 'expandOperation' : ''"
      >
        <el-table-column
          v-if="
            ['admin'].indexOf(userInfo.userType) !== -1 && !bankNoOperatorMode
          "
          type="selection"
          width="46"
        >
        </el-table-column>
        <el-table-column :width="bankNoOperatorMode ? 80 : 60" label="ID">
          <template slot-scope="scope">
            {{ scope.row.id }}
            <div
              v-if="bankNoOperatorMode && scope.row.status.statusLogin === 2"
            >
              <div class="highlight-online">
                <span>已等待</span>
              </div>
              <br />
              <div class="highlight-online">
                <span
                  v-for="(
                    item, index
                  ) in HandleNoOperatorModeTimeStampToDatetimeFormat(
                    scope.row.betweenSecsWithUpdateAndNow
                  )
                    .replace(/\s/g, '')
                    .split('')"
                  :key="index"
                  >{{ item }}</span
                >
              </div>
            </div>
            <div
              class="highlight-online"
              v-if="
                !bankNoOperatorMode &&
                scope.row.minValueGroup &&
                ['admin'].indexOf(userInfo.userType) !== -1
              "
            >
              <span>追款中！</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="300" label="银行卡信息">
          <template slot-scope="scope">
            {{ scope.row.name }}
            <span
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1 &&
                (scope.row.payLimitFull || scope.row.withdrawLimitFull)
              "
              class="warp-full"
            >
              <span v-if="scope.row.payLimitFull">支满</span>
              <span v-if="scope.row.withdrawLimitFull">提满</span>
            </span>
            <span
              class="wrap-flag"
              v-if="['admin'].indexOf(userInfo.userType) !== -1"
            >
            </span>
            <br />
            {{ scope.row.bankName }} ({{ scope.row.bankCode }})
            <el-tooltip
              v-if="
                faceVideoShow(scope.row.faceVideos) &&
                ['admin', 'operator_admin', 'agent', 'agent_assistant'].indexOf(
                  userInfo.userType
                ) !== -1
              "
              content="有扫脸视频"
              placement="top"
            >
              <i
                style="color: #409eff"
                class="face-video-show-icon el-icon-video-camera"
              />
            </el-tooltip>
            <br />
            {{ scope.row.bankCardNumber }}
            <el-tooltip
              content="需扫脸卡"
              placement="top"
              :key="scope.row.id"
              v-if="
                ['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1
              "
            >
              <img
                v-if="scope.row.statusRom"
                style="width: 16px; margin-left: 3px; margin-bottom: -2px"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGmSURBVDiNpZPPShtRFIe/MzNxU0pslRbbRRdFjMQg7aTZBdwUoRuhf5aFeQNLQbTPEPAZdNNFH0DoSkoptHVsAkHsot1I60QbMWoQSTL3dGH8wx1Fxd/y3O9851wuVzQoKbADblHm3la5RGqZ6ZzjymeUtGhQasjcVK8NPV2v5sE8X9/oeLTj9yuFQsVmNrMzDQfcYrK58hrMV5R3JtYp4zjfs0tLL23OxFoUuzimi14qul0H0ij8idpHRxurvj+AiJ7mHVvgRf2DQBogNvBvTWhuC8DdTKXyIMHbBZW2iLps7RpWfhtkG/ruHw7VViuxcaLga5i6FaW2BG5GdaW138E9HFNf9f07F15hWfJtR/UNYAb6pNssRmHSbj5zg6M8qv741tMjhbVazN6BfGqO+2NncScCVRkul4sY8wwYB0YV5OdfATAIZQwfEbPAxJMvCcFwGH4AXp22K9AV2HPnmXgcHAtGwvBhDL9s7HwB0NF7vMhHDkDcffcrRaQXwNNgNjcE+y4sJxhVcYQbBmkmBJ53UMtM59Cg1Ljy9G42szMNue53/g+K3qjDTudCSgAAAABJRU5ErkJggg=="
                alt=""
              />
            </el-tooltip>
            <div v-if="scope.row.buildNo">安全码：{{ scope.row.buildNo }}</div>
            <div v-if="['admin'].indexOf(userInfo.userType) !== -1">
              组别：{{ scope.row.groupName || "-" }}
            </div>
            <template v-if="scope.row.bankGroupCode">
              集团代码：{{ scope.row.bankGroupCode || "-" }}
            </template>

            <el-tooltip
              v-if="
                ['admin'].indexOf(userInfo.userType) !== -1 &&
                [1, 2].indexOf(scope.row.status.accountRatingStatus) !== -1
              "
              :content="
                scope.row.status.accountRatingStatus === 1 ? '观察卡' : '新卡'
              "
              placement="right"
            >
              <span
                v-if="scope.row.status.accountRatingStatus === 1"
                class="bank-bug"
              >
                <svg-icon icon-class="bug" />
                <svg-icon
                  style="width: 12px; color: #ff0000"
                  icon-class="bug"
                />
              </span>
              <span
                v-else-if="scope.row.status.accountRatingStatus === 2"
                class="bank-bug"
                style="font-weight: 600"
              >
                New
              </span>
            </el-tooltip>

            <div>
              <el-tag
                :type="getBankCardTypeParams(scope.row.bankCardType).type"
                size="mini"
              >
                {{ getBankCardTypeParams(scope.row.bankCardType).label }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="查单">
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.checkingPayOrderCount ||
                scope.row.checkingWithdrawOrderCount
              "
              class="cursorPointer"
              @click="HandleOrderCheck(scope.row)"
            >
              <el-tag
                v-if="scope.row.checkingPayOrderCount"
                size="small"
                type="danger"
                effect="dark"
                style="margin-bottom: 5px"
                >支付：{{ scope.row.checkingPayOrderCount }}</el-tag
              >
              <el-tag
                v-if="scope.row.checkingWithdrawOrderCount"
                size="small"
                type="warning"
                effect="dark"
                >提现：{{ scope.row.checkingWithdrawOrderCount }}</el-tag
              >
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column min-width="220" label="卡主用户信息">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="scope.row.username"
              placement="top-start"
              popper-class="username-path-tooltip-class"
            >
              <div
                slot="content"
                v-html="formatUserNamePathTooltip(scope.row.usernamePath)"
              ></div>
              <div size="mini">
                <template v-if="!isFinance">
                  上级：{{
                    scope.row.usernamePath
                      ? scope.row.usernamePath.split("/")[
                          scope.row.usernamePath.split("/").length - 2
                        ]
                      : ""
                  }}
                  <i
                    style="cursor: pointer"
                    @click="
                      CopyTextToClipboard(
                        formatPureUserNamePathTooltip(scope.row.usernamePath)
                      )
                    "
                    class="el-icon-document-copy"
                  ></i>
                </template>
              </div>
            </el-tooltip>
            <div>
              <span
                :class="
                  scope.row.onlineStatus === true
                    ? 'onlineStatusLight'
                    : 'offlineStatusLight'
                "
              ></span>
              {{ scope.row.username }}
              <el-tooltip
                v-if="
                  scope.row.connectionHealthStatus &&
                  scope.row.connectionHealthStatusColorCode
                "
                :content="scope.row.connectionHealthStatus"
                placement="bottom"
              >
                <i
                  @click="HandleLoginRecord(scope.row)"
                  class="el-icon-s-opportunity cursorPointer"
                  :style="`color: ${scope.row.connectionHealthStatusColorCode}`"
                />
              </el-tooltip>
              <i
                @click="CopyTextToClipboard(scope.row.username)"
                class="el-icon-document-copy cursorPointer"
              ></i>
            </div>
            <div>({{ scope.row.isManualUser ? "纯手动卡主" : "卡主" }})</div>
          </template>
        </el-table-column>
        <el-table-column label="派单模式" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.dispatchMode === 0"
              >自动</el-tag
            >
            <el-tag
              size="mini"
              type="warning"
              v-else-if="scope.row.dispatchMode === 1"
              >手动</el-tag
            >
            <el-tag
              size="mini"
              type="success"
              v-else-if="scope.row.dispatchMode === 2"
              >转换中</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isFinance"
          min-width="170"
          align="center"
          label="检测状态"
        >
          <template slot-scope="scope">
            <el-tag
              size="small"
              style="margin: 0 1px 5px 0"
              type="info"
              v-if="scope.row.status.statusCheck === 1"
              >提交检测</el-tag
            >
            <el-tag
              size="small"
              style="margin: 0 1px 5px 0"
              type="wraning"
              v-else-if="scope.row.status.statusCheck === 2"
              >检测中</el-tag
            >
            <el-tag
              size="small"
              style="margin: 0 1px 5px 0"
              type="success"
              v-else-if="scope.row.status.statusCheck === 3"
              >检测通过</el-tag
            >
            <el-tag
              size="small"
              style="margin: 0 1px 5px 0"
              type="danger"
              v-else-if="scope.row.status.statusCheck === 0"
              >未通过检测</el-tag
            >
            <el-tag
              v-for="(item, index) in HandleOrderStatus(scope.row.status)"
              :key="index"
              size="small"
              style="margin: 0 5px 5px 0"
              type="danger"
            >
              {{ item }}
            </el-tag>

            <el-tag
              size="small"
              style="margin: 0 1px 5px 0"
              type="success"
              v-if="scope.row.status.isTakingOrder"
              >接单中</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="上线状态">
          <template slot-scope="scope">
            <el-tag
              size="small"
              type="info"
              v-if="scope.row.status.statusLogin === 0"
              >未使用</el-tag
            >
            <el-tag
              size="small"
              type="info"
              v-else-if="scope.row.status.statusLogin === 1"
              >等待上线</el-tag
            >
            <el-tag
              size="small"
              type="wraning"
              v-else-if="scope.row.status.statusLogin === 2"
              >上线中</el-tag
            >
            <el-tag
              size="small"
              type="success"
              v-else-if="scope.row.status.statusLogin === 3"
              >正常使用中</el-tag
            >
            <el-tag size="small" type="danger" v-else>下线中</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" label="提现接单方式">
          <template slot-scope="scope">
            <template v-if="scope.row.status.dispatchFrequencyType === 1">
              <el-tag size="small" type="success">单次接单</el-tag>
            </template>
            <el-tag
              size="small"
              v-else-if="scope.row.status.dispatchFrequencyType === 2"
              >连续接单</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column v-if="!isFinance" min-width="180" label="积分余额">
          <template slot-scope="scope">
            <span v-if="scope.row.switchShareJifen">
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  scope.row.userJifenBalance,
                  2
                )
              }}
              (共享)
            </span>
            <span v-else>
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  scope.row.jifenBalance,
                  2
                )
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" label="余额">
          <template slot-scope="scope">
            {{
              formatNumberWithCommasAndDecimalSeparator(scope.row.balance, 2)
            }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="['admin', 'sms_admin'].indexOf(userInfo.userType) !== -1"
          width="100"
          label="获取验证码"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="['admin'].indexOf(userInfo.userType) !== -1"
              effect="dark"
              content="验证码"
              placement="top"
            >
              <span
                class="cursorPointer"
                @click="HandleBankAccountVerificationCode(scope.row)"
              >
                <i style="font-size: 20px" class="el-icon-chat-line-square" />
              </span>
            </el-tooltip>
            <el-tooltip effect="dark" content="全部短信" placement="bottom">
              <span
                class="cursorPointer"
                @click="HandleSmsHistoryDialog(scope.row)"
              >
                <i style="font-size: 20px" class="el-icon-tickets" />
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column v-if="!isFinance" width="200" label="错误描述">
          <template slot-scope="scope">
            <span
              v-if="
                ['admin'].indexOf(userInfo.userType) === -1 &&
                scope.row.errorDescription
              "
              >{{
                scope.row.errorDescription.replace(/ *\([^)]*\) */g, "")
              }}</span
            >
            <span v-else>{{ scope.row.errorDescription }}</span>
            <el-button
              v-if="
                [
                  'admin',
                  'agent',
                  'customer',
                  'operator_admin',
                  'agent_assistant',
                  'sms_admin',
                ].indexOf(userInfo.userType) !== -1
              "
              style="margin: 2px auto"
              plain
              icon="el-icon-data-line"
              size="mini"
              @click="HandleBankCardHistory(scope.row)"
            >
              历史纪录
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="['admin'].indexOf(userInfo.userType) !== -1"
          width="110"
          label="上报历史"
        >
          <template slot-scope="scope">
            <el-button
              style="margin: 2px auto"
              plain
              size="mini"
              @click="reportHistory(scope.row)"
            >
              上报历史
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="['admin', 'operator_admin'].indexOf(userInfo.userType) !== -1"
          min-width="150"
          label="操作员"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.operatorUsername"
              :class="
                scope.row.operatorOnlineStatus === true
                  ? 'onlineStatusLight'
                  : 'offlineStatusLight'
              "
            ></span>
            {{ scope.row.operatorUsername || "-" }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isFinance" min-width="120" label="视频状态">
          <template slot-scope="scope">
            <div v-html="getFaceVideoStatus(scope.row.faceVideoStatus)" />
          </template>
        </el-table-column>
        <el-table-column v-if="!isFinance" min-width="150" label="设备">
          <template slot-scope="scope">
            {{ scope.row.cloudPhoneDeviceName }} -
            {{ scope.row.cloudPhoneDeviceNo }}
          </template>
        </el-table-column>
        <el-table-column width="300" label="限额设置">
          <template slot-scope="scope">
            <div>
              每日银行限额：出款
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  scope.row.limit.withdrawDayLimitFromBank,
                  2
                )
              }}
            </div>
            <span v-if="scope.row.limit.enable">
              <div>
                每日主动限额：收款
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.limit.dailyPaymentLimit,
                    2
                  )
                }}，出款
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.limit.dailyWithdrawalLimit,
                    2
                  )
                }}
              </div>
              <!-- <div>
                收款单笔限制：
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.limit.minPaymentLimit,
                    2
                  )
                }}
                -
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.limit.maxPaymentLimit,
                    2
                  )
                }}
              </div>
              <div>
                出款单笔限制：
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.limit.minWithdrawalLimit,
                    2
                  )
                }}
                -
                {{
                  formatNumberWithCommasAndDecimalSeparator(
                    scope.row.limit.maxWithdrawalLimit,
                    2
                  )
                }}
              </div> -->
            </span>
          </template>
        </el-table-column>

        <el-table-column v-if="!isFinance" width="150" label="手机银行帐号">
          <template slot-scope="scope">
            {{ scope.row.onlineBankingUsername }}
          </template>
        </el-table-column>
        <el-table-column width="150" label="手机号">
          <template slot-scope="scope">
            {{ scope.row.phoneNumber }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="['admin'].indexOf(userInfo.userType) !== -1"
          width="200"
          label="协议代理地址"
        >
          <template slot-scope="scope">
            {{ scope.row.proxyHost }}
          </template>
        </el-table-column>

        <el-table-column width="153" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime }}
          </template>
        </el-table-column>
        <el-table-column width="153" label="最后变动时间">
          <template slot-scope="scope">
            {{ scope.row.updatedTime }}
          </template>
        </el-table-column>
        <el-table-column width="200" label="开户银行网点">
          <template slot-scope="scope">
            <span v-if="scope.row.bankProvince"
              >{{ scope.row.bankProvince }} </span
            ><span v-if="scope.row.bankCity">{{ scope.row.bankCity }} </span>
            <span>{{ scope.row.bankBranch }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="['sms_admin'].indexOf(userInfo.userType) === -1"
          :fixed="checkFixed"
          header-align="center"
          :min-width="operationWidth"
          label="操作"
          ref="operation-column"
        >
          <template slot-scope="scope">
            <div @mouseover="expandOperation = true">
              <div v-if="!bankNoOperatorMode">
                <!-- START isOpadminSelectRole 操作员管理员，仅查询权限 operator_select -->
                <div
                  v-if="
                    isOpadminSelectRole &&
                    ['operator_admin'].indexOf(userInfo.userType) !== -1
                  "
                >
                  <el-button
                    style="margin: 2px auto"
                    plain
                    :class="!scope.row.isDeleted ? 'report-button' : ''"
                    size="mini"
                    @click="HandleReport(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    错误标记
                  </el-button>
                  <el-button
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleDetectDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    银行检测
                  </el-button>
                  <el-button
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleCloudyDeviceDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    设备分配
                  </el-button>
                  <el-button
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleConfirmBankCardOnline(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    确认上线
                  </el-button>
                </div>
                <!-- END isOpadminSelectRole 操作员管理员，仅查询权限 operator_select -->

                <div v-else>
                  <el-button
                    v-if="
                      ['admin', 'operator_admin'].indexOf(userInfo.userType) !==
                      -1
                    "
                    style="margin: 2px auto"
                    plain
                    :class="!scope.row.isDeleted ? 'report-button' : ''"
                    size="mini"
                    @click="HandleReport(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    错误标记
                  </el-button>
                  <el-button
                    v-if="
                      [
                        'admin',
                        'agent',
                        'agent_assistant',
                        'sms_admin',
                      ].indexOf(userInfo.userType) !== -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleLimit(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    接单设置
                  </el-button>
                  <el-button
                    v-if="
                      [
                        'agent',
                        'finance',
                        'operator_admin',
                        'agent_assistant',
                        'sms_admin',
                      ].indexOf(userInfo.userType) === -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleEdit(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    信息修改
                  </el-button>
                  <el-button
                    v-if="
                      [
                        'agent',
                        'finance',
                        'operator_admin',
                        'agent_assistant',
                        'sms_admin',
                      ].indexOf(userInfo.userType) === -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleStatus(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    状态管理
                  </el-button>
                  <el-button
                    v-if="
                      [
                        'customer',
                        'admin',
                        'agent',
                        'agent_assistant',
                        'sms_admin',
                      ].indexOf(userInfo.userType) !== -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandlePaymentMode(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    关闭收款
                  </el-button>
                  <el-button
                    v-if="
                      [
                        'admin',
                        'agent',
                        'customer',
                        'operator_admin',
                        'agent_assistant',
                        'sms_admin',
                      ].indexOf(userInfo.userType) !== -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleDetectDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    银行检测
                  </el-button>
                  <el-button
                    v-if="
                      ['super_admin', 'admin'].indexOf(userInfo.userType) !== -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleBankLogDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    银行流水
                  </el-button>
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="clearDayTotalPayJifen(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    清空支付
                  </el-button>
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="clearDayTotalWithdrawJifen(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    清空提现
                  </el-button>
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="priorityWithdrawDispatch(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    优先派单
                  </el-button>
                  <el-button
                    v-if="userInfo.userType === 'admin'"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleTransferUserBankDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    卡号转移
                  </el-button>
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="crossFirstAgentTransferUserBankDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    跨总代转
                  </el-button>

                  <!-- Start 管理员禁用卡号 -->
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    type="danger"
                    @click="HandleCardKill(scope.row)"
                    :disabled="!scope.row.status.userEnable"
                  >
                    禁用卡号
                  </el-button>
                  <!-- End 管理员禁用卡号 -->

                  <!-- Start 通道型代理启/禁用卡号 -->
                  <template
                    v-if="
                      ['agent'].indexOf(userInfo.userType) !== -1 &&
                      userInfo.commonUserType === 1
                    "
                  >
                    <el-button
                      v-if="scope.row.status.userEnable"
                      style="margin: 2px auto"
                      plain
                      size="mini"
                      type="danger"
                      @click="HandleCardKill(scope.row)"
                    >
                      禁用卡号
                    </el-button>
                    <el-button
                      v-else
                      style="margin: 2px auto"
                      size="mini"
                      type="success"
                      @click="handleCardEnableDialog(scope.row)"
                      :disabled="!scope.row.canEnable"
                    >
                      启用卡号
                    </el-button>
                  </template>
                  <!-- End 通道型代理启/禁用卡号 -->

                  <template
                    v-if="
                      ['admin', 'super_admin'].indexOf(userInfo.userType) !== -1
                    "
                  >
                    <el-button
                      v-if="!scope.row.isDeleted"
                      style="margin: 2px auto"
                      plain
                      size="mini"
                      type="danger"
                      @click="HandleDeleteCard(scope.row)"
                    >
                      删除卡号
                    </el-button>
                    <el-button
                      v-else
                      style="margin: 2px auto"
                      plain
                      size="mini"
                      type="success"
                      @click="HandleRecoverCard(scope.row)"
                    >
                      恢复卡号
                    </el-button>
                  </template>
                  <el-button
                    v-if="
                      scope.row.status.userEnable &&
                      userInfo.userType === 'admin' &&
                      scope.row.dispatchMode === 0
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    type="warning"
                    @click="HandleForceLogin(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    重新登录
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'operator_admin'].indexOf(userInfo.userType) !==
                      -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleChooseOperator(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    人工管理
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'operator_admin'].indexOf(userInfo.userType) !==
                        -1 && faceVideoShow(scope.row.faceVideos)
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleFaceVideoPreview(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    视频预览
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'customer'].indexOf(userInfo.userType) !== -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleFaceVideoImport(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    视频汇入
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'operator_admin'].indexOf(userInfo.userType) !==
                        -1 && faceVideoShow(scope.row.faceVideos)
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleFaceStatusPreview(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    视频状态
                  </el-button>
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleScanFace(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    现在扫脸
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'operator_admin'].indexOf(userInfo.userType) !==
                      -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleCloudyDeviceDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    设备分配
                  </el-button>
                  <el-button
                    v-if="['admin'].indexOf(userInfo.userType) !== -1"
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="checkAccSms(scope.row)"
                  >
                    验证短信
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'operator_admin'].indexOf(userInfo.userType) !==
                        -1 && scope.row.dispatchMode === 1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleConfirmBankCardOnline(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    确认上线
                  </el-button>
                  <el-button
                    v-if="
                      userInfo.userType === 'admin' &&
                      scope.row.switchShareJifen === 0
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleBankTopup(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    充值积分
                  </el-button>
                  <el-button
                    v-if="
                      userInfo.userType === 'admin' &&
                      scope.row.switchShareJifen === 0
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="HandleBankRecycle(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    回收积分
                  </el-button>
                  <el-button
                    v-if="isFinance"
                    style="margin: 2px auto; float: right"
                    plain
                    size="mini"
                    @click="HandleTopup(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    提款
                  </el-button>
                  <el-button
                    v-if="
                      scope.row.dispatchMode === 1 &&
                      (['customer'].indexOf(userInfo.userType) !== -1 ||
                        (['admin'].indexOf(userInfo.userType) !== -1 &&
                          userInfo.roles.indexOf('message_admin') !== -1))
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    class="create-chat-room-btn"
                    @click="HandleMessage(scope.row)"
                  >
                    发起对话
                  </el-button>
                  <el-button
                    v-if="
                      ['admin', 'sms_admin'].indexOf(userInfo.userType) !== -1
                    "
                    style="margin: 2px auto"
                    plain
                    size="mini"
                    @click="manualDetectDialog(scope.row)"
                    :disabled="scope.row.isDeleted"
                  >
                    接单检测
                  </el-button>
                </div>
              </div>

              <!-- ============== 未分配操作员 start ============== -->
              <div v-else>
                <el-button
                  style="margin: 2px auto"
                  plain
                  size="mini"
                  @click="HandleConfirmBankCardOnline(scope.row)"
                >
                  确认上线
                </el-button>
                <el-button
                  style="margin: 2px auto"
                  plain
                  size="mini"
                  @click="HandleCloudyDeviceDialog(scope.row)"
                >
                  设备分配
                </el-button>
                <el-button
                  style="margin: 2px auto"
                  plain
                  class="report-button"
                  size="mini"
                  @click="HandleReport(scope.row)"
                >
                  错误标记
                </el-button>
                <el-button
                  style="margin: 2px auto"
                  plain
                  size="mini"
                  @click="HandleChooseOperator(scope.row)"
                >
                  人工管理
                </el-button>
                <el-button
                  style="margin: 2px auto"
                  plain
                  size="mini"
                  @click="HandleDetectDialog(scope.row)"
                >
                  银行检测
                </el-button>
              </div>
              <!-- ============== 未分配操作员 end ============== -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <CusScroll v-if="!tableLoading" ref-target="table" />

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageQuery.pageNum"
        :limit.sync="pageQuery.pageSize"
        @pagination="HandleGetList"
      />
    </div>

    <Dialog @HandleGetList="HandleGetList" :modules="modules" />
    <TopupDialog @HandleGetList="HandleGetList" :modules="modules" />
    <StatusDialog @HandleGetList="HandleGetList" :modules="modules" />
    <LimitDialog
      @HandleGetList="HandleGetList"
      modules="account"
      :fee-rate-list-obj="feeRateListObj"
    />
    <PaymentModeDialog
      @HandleGetList="HandleGetList"
      :payment-mode-obj.sync="paymentModeObj"
    />
    <OperatorDialog @HandleGetList="HandleGetList" :data="operatorData" />
    <BankLogDialog :bank-log-dialog-obj.sync="bankLogDialogObj" />
    <DeleteCard
      @HandleGetList="HandleGetList"
      :delete-card-obj.sync="deleteCardObj"
    />
    <TransferUserBankAccountDialog
      @HandleGetList="HandleGetList"
      :transfer-user-bank-account-obj.sync="transferUserBankAccountObj"
    />
    <!-- 跨总代转移 -->
    <CrossFirstAgentTransferUserBankDialog
      @HandleGetList="HandleGetList()"
      :cross-first-agent-transfer-user-bank-obj.sync="
        crossFirstAgentTransferUserBankObj
      "
    />
    <CloudyDeviceDialog
      @HandleGetList="HandleGetList"
      :cloudy-device-obj.sync="cloudyDeviceObj"
    />
    <DetectDialog :detect-dialog-obj.sync="detectDialogObj" />
    <BankMultipleSelectionDialog
      @HandleGetList="HandleGetList"
      :multiple-selection-dialog-obj.sync="multipleSelectionDialogObj"
    />
    <BankTopupDialog
      @HandleGetList="HandleGetList"
      :bank-topup-dialog-obj.sync="bankTopupDialogObj"
    />
    <BankRecycleDialog
      @HandleGetList="HandleGetList"
      :bank-recycle-dialog-obj.sync="bankRecycleDialogObj"
    />
    <ScanFace :scan-face-obj.sync="scanFaceObj" />
    <EnableDialog :enable-dialog-obj.sync="enableDialogObj" />
    <FaceVideoPreviewDialog
      :face-video-preview-obj.sync="faceVideoPreviewObj"
    />
    <!-- 上报弹窗 -->
    <Report :report-obj="reportData" />
    <OperableVerificationCode
      :operable-verification-code-obj.sync="operableVerificationCodeObj"
    />
    <!-- 短信历程查询 -->
    <SmsHistory :sms-history-obj.sync="smsHistoryObj" />
    <FaceVideoImportDialog
      @HandleGetList="HandleGetList"
      :face-video-import-obj.sync="faceVideoImportObj"
    />
    <!-- 扫脸状态弹窗 -->
    <FaceVideoStatusDialog
      @HandleGetList="HandleGetList"
      :report-obj.sync="reportData"
      :face-video-status-obj.sync="faceVideoStatusObj"
    />
    <!-- 批量协议代理地址弹窗 -->
    <ProxyMultipleSelectionDialog
      @HandleGetList="HandleGetList"
      :proxy-multiple-selection-dialog-obj.sync="
        proxyMultipleSelectionDialogObj
      "
    />

    <!-- 确认上线弹框 -->
    <ConfirmBankCardOnline
      @HandleGetList="HandleGetList"
      :confirm-bank-card-online-obj.sync="confirmBankCardOnlineObj"
    />

    <!-- 查单弹窗 -->
    <OrderCheckDialog :order-check-obj.sync="orderCheckObj" />

    <UserLoginRecordDetail :data="userLoginRecordData" />
    <ReportHistory :report-history-obj.sync="reportHistoryObj" />
    <!-- 模拟派单 -->
    <ManualDetectDialog
      :manual-detect-dialog-obj.sync="manualDetectDialogObj"
    />

    <!-- Start 通道型代理 启/禁用卡号 -->
    <el-dialog
      id="card-enable-dialog"
      top="5vh"
      width="460px"
      center
      :title="`即将启用银行卡「${cardEnableObj.bankCardNumber || ''}」`"
      :visible="cardEnableObj.visible"
      @close="cardEnableObj.visible = false"
    >
      <div class="wrap-notification">
        此银行卡在今日已被管理员和代理启用过
        <span class="text-number-red">{{
          cardEnableObj.enableTimes || 0
        }}</span>
        次
        <br />确定要启用银行卡吗？
      </div>
      <el-link
        @click="
          HandleBankCardHistory({
            id: cardEnableObj.id,
            bankCardNumber: cardEnableObj.bankCardNumber,
          })
        "
        type="primary"
        >历史记录</el-link
      >
      <span slot="footer">
        <el-button size="small" @click="cardEnableObj.visible = false">
          取消
        </el-button>
        <el-button
          size="small"
          :loading="cardEnableObj.submitLoading"
          type="success"
          @click="submitCardEnable()"
        >
          确定启用
        </el-button>
      </span>
    </el-dialog>
    <!-- End 通道型代理 启/禁用卡号 -->
  </div>
</template>

<script>
import FaceVideoImportDialog from "./FaceVideoImportDialog";
import ProxyMultipleSelectionDialog from "./ProxyMultipleSelectionDialog";
import FaceVideoPreviewDialog from "./FaceVideoPreviewDialog";
import FaceVideoStatusDialog from "@/views/components/dialog/FaceVideoStatusDialog";
import Pagination from "@/views/components/Pagination";
import CusScroll from "@/views/components/CusScroll";
import BankTopupDialog from "./BankTopupDialog";
import BankRecycleDialog from "./BankRecycleDialog";
import Dialog from "./Dialog";
import ScanFace from "../bankOperate/ScanFace";
import EnableDialog from "@/views/components/dialog/EnableDialog";
import ReportHistory from "./reportHistory";
import DeleteCard from "./DeleteCard";
import OperableVerificationCode from "@/views/components/dialog/OperableVerificationCode";
import SmsHistory from "@/views/components/dialog/SmsHistory";
import StatusDialog from "@/views/components/dialog/StatusDialog";
import PaymentModeDialog from "./PaymentModeDialog";
import OperatorDialog from "./OperatorDialog";
import BankLogDialog from "./BankLogDialog";
import BankMultipleSelectionDialog from "./BankMultipleSelectionDialog";
import TransferUserBankAccountDialog from "./TransferUserBankAccountDialog";
import CrossFirstAgentTransferUserBankDialog from "./CrossFirstAgentTransferUserBankDialog";
import CloudyDeviceDialog from "./CloudyDeviceDialog";
import OrderCheckDialog from "@/views/components/dialog/OrderCheckDialog";
import LimitDialog from "./LimitDialog";
import TopupDialog from "./TopupDialog";
import DetectDialog from "@/views/components/dialog/DetectDialog";
import ManualDetectDialog from "@/views/components/dialog/ManualDetectDialog";
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import Report from "@/views/components/dialog/Report";
import ConfirmBankCardOnline from "@/views/components/dialog/ConfirmBankCardOnline";
import UserLoginRecordDetail from "@/views/components/dialog/UserLoginRecordDetail";
import {
  getAccountList,
  forceLogin,
  clearDayTotalPayJifen,
  clearDayTotalWithdrawJifen,
  priorityWithdrawDispatch,
  listAmsBankCardPriorityGroupBySelect,
  deleteAccVideo,
  adminDisable,
  accountCardRecover,
  sendCheckAccPhoneSmsRequest,
  editStatus,
  getAdminEnableNum,
} from "@/api/account";
import { getUserNameList } from "@/api/user";
import newIcon from "@/assets/images/new.png";

export default {
  mixins: [mainCommon],
  data() {
    return {
      expandOperation: false, // 预设不展开右侧操作选单
      inRightFixedSpace: false,
      modules: "account",
      bankOptions: [],
      searchOption: {
        statusCheck: [
          { label: "全部检测状态", value: null },
          { label: "提交检测", key: 1, value: "1" },
          { label: "检测中", key: 2, value: "2" },
          { label: "检测通过", key: 3, value: "3" },
          { label: "未通过检测", key: 0, value: "0" },
        ],
        customerStatusLogin: [
          { label: "全部卡主短信心跳状态", value: null },
          { label: "在线", value: true },
          { label: "离线", value: false },
        ],
        statusLogin: [
          { label: "全部上线状态", value: null },
          { label: "未使用", key: 0, value: "0" },
          { label: "等待上线", key: 1, value: "1" },
          { label: "上线中", key: 2, value: "2" },
          { label: "正常使用中", key: 3, value: "3" },
        ],
        userEnable: [
          { label: "全部用户状态", value: null },
          { label: "停用", key: 0, value: "false" },
          { label: "启用", key: 1, value: "true" },
        ],
      },
      dataList: [],
      tableLoading: false,
      operatorData: {},
      pageQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        id: null,
        username: null,
        maxBalance: null,
        maxJifenBalance: null,
        minBalance: null,
        minJifenBalance: null,
        bankNo: null,
        phone: null,
        statusCheck: null,
        statusLogin: null,
        userEnable: null,
        bankCode: null,
        onlineStatus: null,
        isOperatorUser: false,
        hasCloudPhone: false,
        hasFaceVideo: false,
        includeDeleted: null,
        cloudPhoneDeviceNo: null,
        dispatchMode: null,
        specifyAgent: null,
        proxyHost: null,
        accountRatingStatus: null, // 控管策略状态
      },
      total: 0,
      bankLogDialogObj: {},
      transferUserBankAccountObj: {},
      crossFirstAgentTransferUserBankObj: {}, // 跨总代转移
      detectDialogObj: {},
      deleteCardObj: {},
      multipleSelectionDialogObj: {},
      proxyMultipleSelectionDialogObj: {},
      cloudyDeviceObj: {},
      multipleSelection: [],
      amsBankCardPriorityGroupBySelectOptions: [],
      bankTopupDialogObj: {},
      bankRecycleDialogObj: {},
      scanFaceObj: {},
      enableDialogObj: {},
      faceVideoPreviewObj: {},
      // 上报数据
      reportData: {},
      // 确认上线
      confirmBankCardOnlineObj: {},
      operableVerificationCodeObj: {},
      faceVideoImportObj: {},
      faceVideoStatusObj: {},
      smsHistoryObj: {}, // 短信历程查询
      bankNoOperatorMode: false,
      faceVideoStatusOptions: [],
      userLoginRecordData: {},
      orderCheckObj: {}, // 查单
      reportHistoryObj: {},
      // 设置收、付款区间
      feeRateListObj: {
        payFeeRateList: [],
        withdrawFeeRateList: [],
      },
      paymentModeObj: {}, // 收款管理
      manualDetectDialogObj: {}, // 模拟派单
      cardEnableObj: {}, // 通道型代理 启/禁用卡号
      bankCardTypeOptions: varCommon.bankCardTypeOptions, // 银行卡类型
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.bodyWrapper.addEventListener("scroll", this.onScroll);
    });

    // 增加点击 table 缩小右侧选单事件
    document
      .querySelector(".el-table__body-wrapper")
      .addEventListener("click", () => {
        if (!this.inRightFixedSpace) {
          // 在最右边空白处不需要合起来
          this.expandOperation = false;
        }
      });

    // 待分配银行卡，如果有等待时间，就每秒+1
    if (this.bankNoOperatorMode) {
      setInterval(() => {
        this.dataList.forEach((el) => {
          if (el.betweenSecsWithUpdateAndNow) el.betweenSecsWithUpdateAndNow++;
        });
      }, 1000);
    }
  },
  computed: {
    // isOpadminSelectRole 操作员管理员，仅查询权限 operator_select
    isOpadminSelectRole() {
      return this.userInfo.roles.indexOf("opadmin_select") !== -1;
    },
    isFinance() {
      return this.userInfo.userType === "finance";
    },
    bankNoOperate() {
      return this.$store.state.app.unallocatedObj.bankNoOperate;
    },
    // 给操作栏位不同宽度
    operationWidth() {
      if (this.isOpadminSelectRole) {
        return 360;
      } else if (this.bankNoOperatorMode) {
        return 100;
      } else if (this.userInfo.userType === "admin") {
        return 526;
      } else if (this.userInfo.userType === "operator_admin") {
        return 440;
      } else if (
        this.userInfo.userType === "agent" ||
        this.userInfo.userType === "agent_assistant" ||
        this.userInfo.userType === "finance"
      ) {
        return 186;
      } else {
        return 360;
      }
    },
  },
  components: {
    PaymentModeDialog,
    ReportHistory,
    OrderCheckDialog,
    FaceVideoImportDialog,
    FaceVideoStatusDialog,
    ProxyMultipleSelectionDialog,
    FaceVideoPreviewDialog,
    OperableVerificationCode,
    ScanFace,
    DeleteCard,
    OperatorDialog,
    Pagination,
    CusScroll,
    LimitDialog,
    StatusDialog,
    Dialog,
    TopupDialog,
    BankLogDialog,
    BankMultipleSelectionDialog,
    TransferUserBankAccountDialog,
    CloudyDeviceDialog,
    DetectDialog,
    BankTopupDialog,
    BankRecycleDialog,
    EnableDialog,
    Report,
    ConfirmBankCardOnline,
    SmsHistory,
    UserLoginRecordDetail,
    CrossFirstAgentTransferUserBankDialog,
    ManualDetectDialog,
  },
  created() {
    if (this.isFinance) {
      this.pageQuery.statusCheck = "3";
      this.pageQuery.statusLogin = "3";
      this.pageQuery.onlineStatus = true;
      this.pageQuery.userEnable = "true";
    }
    // 判断是否从待分配银行卡路径来
    this.bankNoOperatorMode =
      this.$router.currentRoute.path.indexOf("/account/bankNoOperate") !== -1
        ? true
        : false;

    if (this.userInfo.userType === "operator_admin") {
      // 假设操作员管理员给预设
      this.setOperatorAdminDefaultSearchData();
    }
    this.HandleGetList();
    this.getBankLists();
    this.getListAmsBankCardPriorityGroupBySelect();

    // 产生视频状态筛选选项
    this.faceVideoStatusOptions = this.HandleSelectOption(
      varCommon.faceVideoStatusOptions
    );
  },
  // 离开之前把 store 的 search 清空
  beforeDestroy() {
    this.HandleReset();
    // 移除点击 table 缩小右侧选单事件
    document
      .querySelector(".el-table__body-wrapper")
      .removeEventListener("click", () => {
        this.expandOperation = false;
      });

    if (this.$refs.table) {
      this.$refs.table.bodyWrapper.removeEventListener("scroll", this.onScroll);
    }
  },
  watch: {
    // 根据红点泡泡的变动再一次请求列表
    bankNoOperate() {
      // 如果是在待分配银行卡才刷新列表
      if (this.bankNoOperatorMode) {
        this.HandleGetList();
      }
    },
  },
  methods: {
    onScroll() {
      // 右边预留空白宽度
      const rightFixedSpace =
        this.operationWidth -
        (this.$refs.table.bodyWrapper.scrollWidth -
          this.$refs.table.bodyWrapper.offsetWidth -
          this.$refs.table.bodyWrapper.scrollLeft);

      const element = this.$refs.table.$el.querySelector(
        ".el-table__fixed-right"
      );
      if (element && rightFixedSpace > 100) {
        this.inRightFixedSpace = true;
        this.expandOperation = true;
        element.style.width = `${rightFixedSpace}px`;
      } else {
        if (this.inRightFixedSpace) {
          this.inRightFixedSpace = false;
          this.expandOperation = false;
          element.style.width = `${this.operationWidth}px`;
        }
      }
    },
    // 验证短信
    checkAccSms(row) {
      this.$confirm(
        `银行卡：${row.bankCardNumber
          .match(/.{1,4}/g)
          .join(" ")}<br />确定要验证以上银行卡短信吗？`,
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          sendCheckAccPhoneSmsRequest(row.id).then((res) => {
            this.$notify.success(res.message);
            this.HandleGetList();
          });
        })
        .catch(() => {});
    },
    // 上报历史
    reportHistory(row) {
      this.reportHistoryObj = {
        bankCardNumber: row.bankCardNumber,
        id: row.id,
        visible: true,
      };
    },
    // 支付、提现查单列表
    HandleOrderCheck(row) {
      this.orderCheckObj = {
        visible: true,
        id: row.id,
        bankCardNumber: row.bankCardNumber,
        username: row.username, // 卡主用户名
      };
    },
    // 发起对话
    HandleMessage(row) {
      this.$store.state.app.messageObj = row;
    },
    // 杀银行卡
    HandleCardKill(row) {
      this.$prompt("填写禁用原因", "确定要禁用银行卡吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "可不填写，系统将自动默认原因。",
      })
        .then(({ value }) => {
          adminDisable(row.id, { specialRemark: value }).then((res) => {
            this.$notify.success(res.message);
            this.HandleGetList();
          });
        })
        .catch(() => {});
    },

    /* --- Start 通道型代理 启/禁用卡号 --- */
    // 启用卡号弹框
    handleCardEnableDialog(row) {
      getAdminEnableNum(row.id).then((res) => {
        this.cardEnableObj = {
          id: row.id,
          bankCardNumber: row.bankCardNumber,
          submitLoading: false,
          visible: true,
          enableTimes: res.data.enableTimes,
        };
      });
    },
    // 提交启用卡号
    submitCardEnable() {
      this.cardEnableObj.submitLoading = true;
      editStatus({
        id: this.cardEnableObj.id,
        userEnable: true,
      })
        .then((res) => {
          this.HandleGetList();
          this.cardEnableObj = {};
          this.$notify.success(res.message);
        })
        .finally(() => {
          this.cardEnableObj.submitLoading = false;
        });
    },
    /* --- End 通道型代理 启/禁用卡号 --- */

    // 有扫脸视频
    faceVideoShow(faceVideos) {
      return faceVideos.find((item) => item.videoPath !== null);
    },
    // 扫脸视频汇入
    HandleFaceVideoImport(row) {
      this.faceVideoImportObj = {
        id: row.id,
        userId: row.userId,
        bankName: row.bankName,
        bankCardNumber: row.bankCardNumber,
        visible: true,
      };
    },
    // 视频状态
    getFaceVideoStatus(status) {
      let text = varCommon.faceVideoStatusOptions[status];
      switch (status) {
        case 0:
          return `<i class="el-icon-error"> ${text} </i>`;
        case 1:
          return `<img src="${newIcon}" style="width: 40px; vertical-align: middle;" /> <span style="color: #ffb229">${text}</span>`;
        case 2:
          return `<i style="color: #67C23A" class="el-icon-circle-check"> ${text} </i>`;
        case 3:
          return `<i style="color: #5be63c" class="el-icon-success"> ${text} </i>`;
        case 4:
          return `<i style="color: #ff0000" class="el-icon-error"> ${text} </i>`;
      }
    },
    // 视频状态
    HandleFaceStatusPreview(row) {
      this.faceVideoStatusObj = {
        id: row.id,
        bankName: row.bankName,
        bankCardNumber: row.bankCardNumber,
        faceVideoStatus: row.faceVideoStatus,
        visible: true,
      };
    },
    // 视频预览
    HandleFaceVideoPreview(row) {
      this.faceVideoPreviewObj = {
        id: row.id,
        userId: row.userId,
        bankName: row.bankName,
        bankCardNumber: row.bankCardNumber,
        visible: true,
      };
    },
    // 获取验证码
    HandleBankAccountVerificationCode(row) {
      this.operableVerificationCodeObj = {
        id: row.id,
        bankName: row.bankName,
        visible: true,
      };
    },
    // 短信历程查询
    HandleSmsHistoryDialog(row) {
      this.smsHistoryObj = {
        id: row.id,
        bankCardNumber: row.bankCardNumber,
        visible: true,
      };
    },
    // 现在扫脸
    HandleScanFace(row) {
      this.scanFaceObj = {
        id: row.id,
        bankName: row.bankName,
        bankCardNumber: row.bankCardNumber,
        faceVideos: row.faceVideos,
        visible: true,
      };
    },
    // 历史纪录
    HandleBankCardHistory(row) {
      this.enableDialogObj = {
        id: row.id,
        bankCardNumber: row.bankCardNumber,
        visible: true,
      };
    },
    // 取得 groupCode 给 filter 使用
    getListAmsBankCardPriorityGroupBySelect() {
      listAmsBankCardPriorityGroupBySelect().then((res) => {
        this.amsBankCardPriorityGroupBySelectOptions = res.data.map((res) => {
          return { label: res.groupName, value: res.groupCode };
        });
      });
    },
    // 充值积分
    HandleBankTopup(row) {
      this.bankTopupDialogObj = {
        id: row.id,
        username: row.username,
        bankCardNumber: row.bankCardNumber,
        visible: true,
      };
    },
    // 回收积分
    HandleBankRecycle(row) {
      this.bankRecycleDialogObj = {
        id: row.id,
        username: row.username,
        bankCardNumber: row.bankCardNumber,
        visible: true,
      };
    },
    // 删除
    HandleDeleteCard(row) {
      this.deleteCardObj = row;
      this.deleteCardObj.visible = true;
    },
    // 恢复卡号
    HandleRecoverCard(row) {
      this.$confirm(
        `确定要恢复「${
          row.bankCardNumber
            ? row.bankCardNumber.match(/.{1,4}/g).join(" ")
            : ""
        }」银行卡？`,
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          accountCardRecover(row.id).then((res) => {
            this.$notify.success(res.message);
            this.HandleGetList();
          });
        })
        .catch(() => {});
    },
    // 银行流水
    HandleBankLogDialog(row) {
      this.bankLogDialogObj = row;
      this.bankLogDialogObj.visible = true;
    },
    // 模拟派单
    manualDetectDialog(row) {
      this.manualDetectDialogObj = row;
      this.manualDetectDialogObj.visible = true;
    },
    // 检测
    HandleDetectDialog(row) {
      this.detectDialogObj = row;
      this.detectDialogObj.visible = true;
    },
    // 转移
    HandleTransferUserBankDialog(row) {
      this.transferUserBankAccountObj = row;
      this.transferUserBankAccountObj.visible = true;
    },
    // 跨总代转移
    crossFirstAgentTransferUserBankDialog(row) {
      this.crossFirstAgentTransferUserBankObj = row;
      this.crossFirstAgentTransferUserBankObj.visible = true;
    },
    // 设备分配
    HandleCloudyDeviceDialog(row) {
      this.cloudyDeviceObj = {
        data: row,
        visible: true,
      };
    },
    // 协议地址批量操作
    HandleProxyMultipleSelectionDialog() {
      if (this.multipleSelection.length === 0) {
        this.$notify.error("未选择银行卡！");
        return;
      }
      let multipleSelectionHasProxyLength = this.multipleSelection.filter(
        (item) => {
          return item.proxyHost && item.proxyPoolId;
        }
      ).length;
      if (this.multipleSelection.length !== multipleSelectionHasProxyLength) {
        this.$notify.error(
          `该银行卡必须要有协议地址才可以被修改，你所选择的银行卡中有 ${
            this.multipleSelection.length - multipleSelectionHasProxyLength
          } 笔没有协议代理地址唷！`
        );
        return;
      }

      this.proxyMultipleSelectionDialogObj = {
        data: this.multipleSelection,
        visible: true,
      };
    },
    // 级距批量操作
    HandleBankMultipleSelectionDialog() {
      if (this.multipleSelection.length === 0) {
        this.$notify.error("未选择银行卡！");
        return;
      }
      this.multipleSelectionDialogObj = {
        data: this.multipleSelection,
        visible: true,
      };
    },
    // 批量移除视频
    HandleBankMultipleDeleteAccVideo() {
      if (this.multipleSelection.length === 0) {
        this.$notify.error("未选择银行卡！");
        return;
      }
      let confirmTitle = "移除";
      if (this.multipleSelection.length > 1) {
        confirmTitle = "批量移除";
      }
      this.$confirm(
        `确定${confirmTitle} ${this.multipleSelection
          .map(({ id }) => id)
          .join()} 视频？`,
        confirmTitle + "视频",
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "error",
        }
      )
        .then(() => {
          deleteAccVideo({
            accIdList: this.multipleSelection.map(({ id }) => id),
          }).then((res) => {
            this.$notify.success(res.message);
            this.HandleGetList();
          });
        })
        .catch(() => {});
    },
    // autocomplete操作员，返回输入建议的方法属性
    querySuggestOperator(queryString, cb) {
      this.suggestOperatorArray = [];
      getUserNameList({ userType: "operator", username: queryString }).then(
        (res) => {
          res.data.forEach((el) => {
            this.suggestOperatorArray.push({ value: el.userName });
          });
        }
      );
      cb(this.suggestOperatorArray);
    },
    setOperatorAdminDefaultSearchData() {
      this.pageQuery.onlineStatus = true;
      this.pageQuery.statusCheck = "3";
      // this.pageQuery.statusLogin = "3";
      this.pageQuery.userEnable = "true";
      // 如果操作员管理员在待分配银行卡列表时，isOperatorUser 给 false
      this.pageQuery.isOperatorUser = this.bankNoOperatorMode ? false : true; // 仅查询已指派操作员
    },
    HandleChooseOperator(row) {
      this.operatorData = {
        operatorUsername: row.operatorUsername,
        bankCardNumber: row.bankCardNumber,
        accId: row.id,
      };
    },
    getBankLists() {
      let queryObj = {};
      if (this.userInfo.userType === "operator_admin") {
        // 支持模式: 0自动, 1手动
        queryObj = { supportMode: 1 };
      }
      this.$store.dispatch("ToggleBankLists", queryObj).then((res) => {
        this.bankOptions = [];
        res.forEach((el) => {
          this.bankOptions.push({
            label: `${el.bankName} (${el.bankCode})`,
            value: el.bankCode,
          });
        });
        this.bankOptions.unshift({ label: "全部银行", value: null });
      });
    },
    HandleForceLogin(row) {
      this.$confirm("确定强制重新登录？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "error",
      })
        .then(() => {
          forceLogin(row.id).then((res) => {
            this.$notify.success(res.message);
          });
        })
        .catch(() => {});
    },
    HandleLimit(row) {
      this.feeRateListObj = {
        payFeeRateList: row.payFeeRateList,
        withdrawFeeRateList: row.withdrawFeeRateList,
      };

      let tmpData = row.limit;
      tmpData.dispatchMode = row.dispatchMode; // 加入判断手、自动卡
      this.$store.commit(`${this.modules}/SET_LIMIT_EDIT_OBJ`, tmpData);
      this.HandleSetState(this.modules, "/SET_STATE", {
        id: row.id,
        limitDialogVisible: true,
      });
    },
    HandleOrderStatus(status) {
      let arr = [];
      // 若为 "接单中"
      if (!status.isTakingOrder) {
        if (!status.canPay) arr.push("无法支付");
        if (!status.canWithdraw) arr.push("无法提现");
        if (status.isAccError) arr.push("帐号异常");
        if (!status.userEnable) arr.push("用户禁用");
      }
      if (status.isAccRiskControl) arr.push("帐号风控");
      if (status.isSmsDelay) arr.push("短信延迟");
      return arr;
    },
    // 关闭收款
    HandlePaymentMode(row) {
      this.paymentModeObj = {
        isWithdrawOnly: row.status.isWithdrawOnly,
        bankCardNumber: row.bankCardNumber,
        id: row.id,
        visible: true,
      };
    },
    HandleStatus(row) {
      // 检测状态除了 3 检测通过以外都当做未通过
      if (row.status.statusCheck === 3) {
        // 检测通过
        row.status.isCheckOK = true;
      } else {
        row.status.isCheckOK = false;
      }
      this.$store.commit(`${this.modules}/SET_STATUS_EDIT_OBJ`, row.status);
      this.$store.commit(`${this.modules}/SET_STATUS_EDIT`, {
        id: row.id,
        bankCardNumber: row.bankCardNumber,
        balance: row.balance, // 银行卡启用时，提示卡主更新余额
        dispatchMode: row.dispatchMode, // 派单模式
      });
      this.HandleSetState(this.modules, "/SET_STATE", {
        statusDialogVisible: true,
      });
    },
    HandleTopup(row) {
      this.HandleSetState(this.modules, "/SET_STATE", {
        bankCardNumber: row.bankCardNumber,
        bankName: row.bankName,
        id: row.id,
        topupDialogVisible: true,
      });
    },
    HandleEdit(row) {
      this.$store.commit(`${this.modules}/SET_EDIT_OBJ`, row);
      this.$store.commit(`${this.modules}/SET_EDIT`, { accId: row.id });
      this.HandleSetState(this.modules, "/SET_STATE", { dialogVisible: true });
    },
    HandleSearch() {
      this.pageQuery.pageNum = 1;
      this.HandleGetList();
    },
    HandleReload() {
      this.HandleGetList(true);
    },
    HandleReset() {
      this.pageQuery.id = null;
      this.pageQuery.username = null;
      this.pageQuery.maxBalance = null;
      this.pageQuery.maxJifenBalance = null;
      this.pageQuery.minBalance = null;
      this.pageQuery.minJifenBalance = null;
      this.pageQuery.bankNo = null; // 银行卡号码
      this.pageQuery.phone = null; // 手机银行帐号
      this.pageQuery.statusCheck = null; // 状态
      this.pageQuery.statusLogin = null; // 上线状态
      this.pageQuery.userEnable = null; // 检测状态
      this.pageQuery.bankCode = null; // 银行代码
      this.pageQuery.onlineStatus = null; // 卡主上线状态
      this.pageQuery.isOperatorUser = false; // 仅查询已指派操作员
      this.pageQuery.hasCloudPhone = false; // 仅查询已分配设备
      this.pageQuery.hasFaceVideo = false; // 仅查询已上传扫脸视频
      this.pageQuery.includeDeleted = null; // 仅查询已删除银行卡
      this.pageQuery.cloudPhoneDeviceNo = null; // 设备编号
      this.pageQuery.dispatchMode = null; // 派单模式
      this.pageQuery.specifyAgent = null; // 仅查询指定代理
      this.pageQuery.isBank = false; // 待分配银行卡
      this.pageQuery.faceVideoStatus = null; // 视频状态
      this.pageQuery.proxyHost = null;
      this.pageQuery.accountRatingStatus = null; // 控管策略状态
      if (this.userInfo.userType === "operator_admin") {
        // 假设操作员管理员给预设
        this.setOperatorAdminDefaultSearchData();
      }
      this.HandleSearch();
    },
    // statusCheck、statusLogin、userEnable、onlineStatus
    HandleStatusReset() {
      this.pageQuery.statusCheck = null; // 状态
      this.pageQuery.statusLogin = null; // 上线状态
      this.pageQuery.userEnable = null; // 检测状态
      this.pageQuery.onlineStatus = null; // 银行代码
      this.HandleSearch();
    },
    HandleAdd() {
      this.HandleSetState(this.modules, "/SET_STATE", { dialogVisible: true });
    },
    HandleGetList(reloadNotify) {
      this.tableLoading = true;
      // 操作员管理员直接显示手动卡
      if (this.userInfo.userType === "operator_admin") {
        this.pageQuery.dispatchMode = 1;
      }
      // 如果是从待分配银行卡来的
      if (this.bankNoOperatorMode) {
        this.pageQuery.isBank = true;
      }
      getAccountList(this.ObjectClean(this.pageQuery))
        .then((res) => {
          if (reloadNotify) {
            this.$notify.success("刷新成功");
          }
          this.total = res.data.total;
          this.dataList = res.data.list;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 清空今日支付跑量
    clearDayTotalPayJifen(row) {
      this.$confirm(
        `确定清空今日支付跑量？「${row.id}」`,
        "清空今日支付" + varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          clearDayTotalPayJifen(row.id).then((res) => {
            this.$notify.success(res.message);
          });
        })
        .catch(() => {});
    },
    // 清空今日提现跑量
    clearDayTotalWithdrawJifen(row) {
      this.$confirm(
        `确定清空今日提现跑量？「${row.id}」`,
        "清空今日提现" + varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          clearDayTotalWithdrawJifen(row.id).then((res) => {
            this.$notify.success(res.message);
          });
        })
        .catch(() => {});
    },
    // 优先提现派单
    priorityWithdrawDispatch(row) {
      this.$confirm(
        `确定优先提现派单？「${row.id}」`,
        "优先提现派单" + varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          priorityWithdrawDispatch(row.id).then((res) => {
            this.$notify.success(res.message);
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    HandleReport(row) {
      this.reportData = {
        id: row.id,
        bankName: row.bankName,
        bankCardNumber: row.bankCardNumber,
      };
    },
    // 确认上线弹框
    HandleConfirmBankCardOnline(row) {
      this.confirmBankCardOnlineObj = {
        id: row.id,
        bankName: row.bankName,
        bankCardNumber: row.bankCardNumber,
        statusRom: row.statusRom,
        visible: true,
      };
    },
    // 开启上下线记录详情 Dialog
    HandleLoginRecord(row) {
      this.userLoginRecordData = {
        id: row.userId,
        username: row.username,
      };
    },
    // 将「秒数」转换为 分, 秒
    HandleNoOperatorModeTimeStampToDatetimeFormat(time) {
      if (!time) return "-";
      let t = Number(time);
      let m = Math.floor(t / 60);
      let s = Math.floor((t % 3600) % 60);
      let mDisplay = m > 0 ? m + " 分 " : "";
      let sDisplay = s > 0 ? s + " 秒" : "";
      return mDisplay + sDisplay;
    },
    // 取得对应银行卡类型物件
    getBankCardTypeParams(val) {
      return (
        this.bankCardTypeOptions.find((item) => item.value === val) || {
          label: "-",
          type: "",
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// 启用卡号弹框
#card-enable-dialog {
  .wrap-notification {
    font-size: 16px;
    line-height: 40px;
    .text-number-red {
      color: #ff0000;
      font-size: 22px;
    }
  }
}
.create-chat-room-btn {
  color: #b9a9fd;
  background: #fff;
  border-color: #b9a9fd;
  &:hover {
    color: #b9a9fd;
    background: #efecff;
    border-color: #b9a9fd;
  }
}

/deep/ .el-table td {
  padding: 2px 0;
}
/deep/ .el-table__fixed-right {
  transition: width 0.1s;
  // transition-timing-function: ease-in-out;
  box-shadow: 0 0 10px #0000002f;
}
.expandOperation /deep/ .el-table__fixed-right {
  width: 100px !important;
}
/deep/ .el-table__body tr.hover-row.current-row > td,
/deep/ .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
/deep/ .el-table__body tr.hover-row.el-table__row--striped > td,
/deep/ .el-table__body tr.hover-row > td {
  background-color: #e7f0fe;
}
.warning-text {
  font-size: 13px;
  font-weight: 600;
}
.pass-text {
  font-size: 13px;
  color: #67c23a;
  font-weight: 600;
}

.face-video-show-icon {
  animation: face-video-show-icon 1s infinite;
}

@keyframes face-video-show-icon {
  0% {
    color: #409eff;
  }
  50% {
    color: #f7bc64;
  }
  100% {
    color: #409eff;
  }
}

.report-button {
  -webkit-animation: table-report-button 1.222s infinite;
  animation: table-report-button 1.222s infinite;
}

@keyframes table-report-button {
  0% {
    color: #ff0000;
  }
  50% {
    color: #ef9713;
  }
  100% {
    color: #ff0000;
  }
}

.highlight-online {
  position: absolute;
  width: 80px;
  letter-spacing: 1px;
  -webkit-box-reflect: below -12px linear-gradient(transparent, rgba(0, 0, 0, 0.4));
  font-size: 14px;
  font-weight: 600;
  z-index: 10;
  transform: translateX(-50%);
  left: 50%;
  text-align: center;
}
.highlight-online span {
  display: inline-block;
  color: #ff0000;
}

.bank-bug {
  position: absolute;
  right: 10px;
  top: 10px;
  animation: bank-bug-ani 1.6s infinite;
  svg {
    position: absolute;
    width: 15px;
    color: #fcaa25;
    left: 50%;
    transform: translateX(-50%);
  }
}
@keyframes bank-bug-ani {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    transform: translateY(2px) scale(1);
    opacity: 1;
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateY(0px) scale(1);
    opacity: 0.6;
  }
}
.warp-full {
  span {
    font-size: 12px;
    display: inline-block;
    padding: 0px 2px;
    border-radius: 8px;
    margin-left: 2px;
    border: 0.8px solid #a0a0a0;
    color: #fff;
    font-weight: 600;
    background: #eb3725;
    background: linear-gradient(
      to bottom,
      #eb3725 0%,
      #e0645e 36%,
      #eb3725 100%
    );
    box-shadow: 0 0.6px 0.6px 0.6px rgba(0, 0, 0, 0.4);
    transform: scale(1);
    animation: fullAnimation 1s ease-out infinite;
    &:nth-child(1) {
      animation-delay: 0.2s;
    }
  }
}
@keyframes fullAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

// 支查提查按钮
.wrap-flag {
  /deep/ .el-button--mini,
  .el-button--mini.is-round {
    padding: 4px 8px;
  }
  .el-button + .el-button {
    margin-left: 1px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/index.vue